export const PERSIST_STATE_KEY = 'startup-craft'

export const UI_STATE = 'ui'
export const CALCULATOR_STATE = 'calculator'

export const UI_ACTIONS = {
  UPDATE: `${UI_STATE}/update`,
}

export const CALCULATOR_ACTIONS = {
  UPDATE: `${CALCULATOR_STATE}/update`,
}
